module.exports = __webpack_public_path__ + "static/media/service-custom-application-development.791cb76d.png";